import { render, staticRenderFns } from "./SlideComponent.vue?vue&type=template&id=4a69f56f&scoped=true&"
import script from "./SlideComponent.vue?vue&type=script&lang=js&"
export * from "./SlideComponent.vue?vue&type=script&lang=js&"
import style0 from "./SlideComponent.vue?vue&type=style&index=0&id=4a69f56f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a69f56f",
  null
  
)

export default component.exports